<a class="member-club-link" [routerLink]="item.link.url"
   [title]="'club.points.numOfPointsLabel' | translateSafe : {points: (clubPoints$ | async)?.points || 0}">
    <span
        class="kk-visuallyhidden">{{ 'general.accessibility.goTo' | translateSafe: { destination: item.link.name } }}</span>
    <img
        class="member-club-icon"
        [src]="item.icon?.src"
        [alt]="item.icon?.name"
        [width]="item.icon?.width"
        [height]="item.icon?.height"
    />

    @if ((clubPoints$ | async); as points) {
        @if (points.points > 0) {
            <app-badge @fadeIn [label]="'club.points.numOfPointsLabel' | translateSafe : {points: points.points}" color="red" >
                {{ points.points | moreThan }}
            </app-badge>
        }
    }
</a>
